import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=5e819337&scoped=true"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=5e819337&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e819337",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e819337')) {
      api.createRecord('5e819337', component.options)
    } else {
      api.reload('5e819337', component.options)
    }
    module.hot.accept("./UserRole.vue?vue&type=template&id=5e819337&scoped=true", function () {
      api.rerender('5e819337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/UserRole.vue"
export default component.exports